<form-field-label [labelTranslateKey]="'description'"></form-field-label>
<mat-form-field class="description-container" appearance="outline">
	<textarea
		matInput
		cdkTextareaAutosize
		[cdkAutosizeMinRows]="tabs()"
		[formControl]="descriptionForm"
		[placeholder]="'description' | translate"
		(blur)="onBlur()"
	></textarea>
</mat-form-field>
